export default __webpack_public_path__ + "static/media/dashboard_top_banner.227ed1d2.png";